import { Enums } from '@bode-canada/core';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ListingGalleryActionTitle } from '../enums';
import BaseOpenModalAction from '@/components/listing-card/helpers/base-open-modal.action';
import ModalService from '@/ui-kit/components/modal/ModalService';
import routes from '@/constants/routes';
import { track } from '@/utils/analytics';
import ListingGalleryImagesModal from '../images-modal';
import { LISTING_TRACK_EVENT_ORIGIN_TYPES } from '@/constants';

export default class SeePhotosAction extends BaseOpenModalAction {
  title = ListingGalleryActionTitle.SeePhotos;
  icon = IconType.Camera;
  colorSchema = StyleColorSchemeType.Gray;

  // eslint-disable-next-line class-methods-use-this
  openModal(listing) {
    const isSoldProperty = window.location.pathname.includes(routes.soldProperty);
    const { origin, listingId } = listing;
    const eventOrigin = origin === Enums.ListingOriginEnum.BODE
      ? Enums.ListingOriginEnum.BODE
      : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;

    if (isSoldProperty) {
      track(`${eventOrigin}_Sold Property_Photos viewed`, {
        listingId,
        listingType: eventOrigin,
      });
    }

    return ModalService.open({
      component: ListingGalleryImagesModal,
      data: { ...this.modalData, listing },
    });
  }
}
